import type { LiveKit } from './types.js';
import type { Device } from '@studio/models/device';
import { AspectRatio } from '@studio/models/video';
import QuickLRU from 'quick-lru';

/** @internal */
export const locationCache = {
  local: new QuickLRU<Device['id'], LiveKit['id']>({
    maxSize: 100
  }),

  cloud: new QuickLRU<Device['id'], LiveKit['id']>({
    maxSize: 100
  })
};

/** @internal */
export const ThumbnailConfig = Object.freeze({
  height: 512 / AspectRatio, // 144px
  mimeType: 'image/jpeg',
  quality: 0.8,
  width: 512
});

/**
 * How long a video element can go without a new frame before the app treats
 * it as stalled. The video tile's stall watchdog starts recovery after this,
 * and onboarding's Magic Moment stops showing LIVE after it. One value keeps
 * "stalled" meaning the same thing on every screen.
 */
export const VIDEO_STALL_MS = 3_000;
